import { Box, Fade, IconButton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ChipStatus from 'packages/ui/ChipStatus'

import { type DeliverySource } from '../types'
import { formatNumber } from '../utils'
import SendsTable from './SendsTable'

type DeliverySourceDetailsProps = {
  source: DeliverySource
  onBack: () => void
}

const DeliverySourceDetails = ({ source, onBack }: DeliverySourceDetailsProps) => {
  const { t } = useTranslation()
  return (
    <Fade in timeout={180}>
      <Stack gap={2} sx={{ flex: 1, minHeight: 0 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          gap={2}
          sx={{ flexShrink: 0 }}
        >
          <Stack direction="row" alignItems="center" gap={1.5} minWidth={0}>
            <IconButton
              onClick={onBack}
              sx={{
                width: 28,
                height: 28,
                border: '1px solid #EFEFEF',
                color: '#464646'
              }}
            >
              <Box component="i" className="fa-light fa-arrow-left" sx={{ fontSize: 12 }} />
            </IconButton>

            <Stack gap={0.25} minWidth={0}>
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography
                  sx={{
                    color: '#464646',
                    fontSize: 16,
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {source.name}
                </Typography>
                <ChipStatus
                  status={source.source_type}
                  color={source.source_type === 'campaign' ? '#2570EB' : '#9A6700'}
                  bgcolor={source.source_type === 'campaign' ? '#E4EEFA' : '#FEF4E9'}
                  borderRadius="8px"
                />
              </Stack>
              <Typography sx={{ color: '#989898', fontSize: 10, fontWeight: 500 }}>
                {source.template_code}
              </Typography>
            </Stack>
          </Stack>

          <Typography sx={{ color: '#656565', fontSize: 12, fontWeight: 500 }}>
            {t('mailing.history.nb_emails', {number: formatNumber(source.email_count)})}
          </Typography>
        </Stack>

        <SendsTable
          initialSourceType={source.source_type}
          initialSourceId={source.id}
          showFilters={false}
        />
      </Stack>
    </Fade>
  )
}

export default DeliverySourceDetails
